import { Component, Inject, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ComponentStore } from "@ngrx/component-store";
import { Store } from "@ngrx/store";
import { AllUnitAreaMeasurementsRequested, AllUnitLengthMeasurementsRequested, selectAllUnitAreaMeasurements, selectAllUnitLengthMeasurements } from "src/app/core/linked-tables";
import { LandArea } from "src/app/core/v3/land-area";

export interface LandAreaDialogInput {
  item?: LandArea
}
export interface LandAreaDialogOutput {
  item: LandArea
}

interface State {
  title: string
}

@Component({
  selector: 'app-land-area-dialog',
  templateUrl: './land-area-dialog.component.html',
  styleUrls: ['./land-area-dialog.component.scss'],
  providers: [ComponentStore]
})
export class LandAreaDialogComponent implements OnInit {
  form = new FormGroup({
    unit_area_measurement_id: new FormControl<number>(null, [Validators.required]),
    surface: new FormControl<number>(null, [Validators.required]),
    limited_use: new FormControl<string>(null),
    underground_restriction: new FormControl<number>(null),
    aerial_restriction: new FormControl<number>(null),
    unit_length_measurement_id: new FormControl<number>(null)
  })

  title$ = this.componentStore.select(state => state.title)
  unitAreaMeasurements$ = this.ngStore.select(selectAllUnitAreaMeasurements)
  unitLengthMeasurements$ = this.ngStore.select(selectAllUnitLengthMeasurements)

  constructor(
    public dialogRef: MatDialogRef<LandAreaDialogComponent, LandAreaDialogOutput|undefined>,
    @Inject(MAT_DIALOG_DATA) public data: LandAreaDialogInput,
    private ngStore: Store,
    private componentStore: ComponentStore<State>
  ) {
    this.componentStore.setState({
      title: data?.item ? 'Edit Component' : 'New Component'
    })

    if (data && data.item) {
      this.form.patchValue({
        unit_area_measurement_id: data.item.unitAreaMeasurementId,
        unit_length_measurement_id: data.item.unitLengthMeasurementId,
        surface: data.item.surface,
        limited_use: data.item.limitedUse,
        underground_restriction: data.item.undergroundRestriction,
        aerial_restriction: data.item.aerialRestriction
      })
    }
  }

  ngOnInit(): void {
    this.ngStore.dispatch(new AllUnitAreaMeasurementsRequested())
    this.ngStore.dispatch(new AllUnitLengthMeasurementsRequested())
  }

  onClose() {
    this.dialogRef.close()
  }
  onSubmit() {
    const controls = this.form.controls
    if (this.form.invalid) {
      Object.keys(controls).forEach(controlName => {
        controls[controlName].markAsTouched()
      })
      return;
    }

    const landArea: LandArea = {
      limitedUse: controls.limited_use.value,
      surface: controls.surface.value,
      undergroundRestriction: controls.underground_restriction.value,
      aerialRestriction: controls.aerial_restriction.value,
      unitAreaMeasurementId: controls.unit_area_measurement_id.value,
      unitLengthMeasurementId: controls.unit_length_measurement_id.value
    }

    this.dialogRef.close({
      item: landArea
    })
  }
}